function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M225.5 255.118c12.426 0 22.5-10.074 22.5-22.5 0-12.427-10.074-22.5-22.5-22.5s-22.5 10.073-22.5 22.5c0 12.426 10.074 22.5 22.5 22.5z",
  fill: "#00645F"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#006C5D",
  d: "M0 331.118h2166v70H0z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.15,
  d: "M455 331.404s-14.558-91.473-76.202-113.984c-80.189-29.27-97.133 51.638-115.032 74.482-8.663 11.065-53.22-36.408-133.647-14.516C88.522 288.713 59 332.118 59 332.118l396-.714z",
  fill: "url(#house-with-surroundings_svg__house-with-surroundings_svg__paint0_linear)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.29,
  d: "M30 331.882l425-.764s-108.987 44.791-285.702 33.032C48.745 356.139 30 331.882 30 331.882z",
  fill: "#070634"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.15,
  d: "M1691 334.118s3.79-72.393 74.27-100.177c85.66-33.787 136.96 52.687 151.51 54.577 14.56 1.89 34.19-31.376 81.13-27.407 67.04 5.671 113.09 71.353 113.09 71.353l-420 1.654z",
  fill: "url(#house-with-surroundings_svg__house-with-surroundings_svg__paint1_linear)"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1641 332.118l470 .24s-306.09 27.145-360.97 25.704c-40.65-1.057-109.5-23.062-109.03-25.944z",
  fill: "#005054"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1741 358.118s-5.47-30.812-37.87-32c0 0-36.24 1.94-37.13 31.854l75 .146z",
  fill: "#00A872"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M2065 354.118c22.09 0 40-17.909 40-40 0-22.092-17.91-40-40-40s-40 17.908-40 40c0 22.091 17.91 40 40 40z",
  fill: "url(#house-with-surroundings_svg__house-with-surroundings_svg__paint2_linear)"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M2053.26 275.677a39.72 39.72 0 00-17.26 10.196l47.69 33.245s21.63-7.037 19.1-15.821c-6.08-21.373-28.25-33.723-49.53-27.62z",
  fill: "url(#house-with-surroundings_svg__house-with-surroundings_svg__paint3_linear)"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#F7E7DD",
  d: "M0 384.118h2166v18H0z"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M938 384.118c2.093-.837 47.748-24.502 47.748-24.502L1195 354.118l-78.71 10.996L938 384.118z",
  fill: "#005054"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M743.5 342.118c45.563 0 82.5-38.504 82.5-86 0-47.497-36.937-86-82.5-86s-82.5 38.503-82.5 86c0 47.496 36.937 86 82.5 86z",
  fill: "#00645F"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.39,
  d: "M703.338 180.679c-16.955 9.784-28.968 24.661-35.338 41.635 29.234 12.283 80 31.804 80 31.804l-12.764-84a82.507 82.507 0 00-31.898 10.561z",
  fill: "#00986D"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M560 332.118l92.433 52h160.17L833 346.081l-169.341-12.278L560 332.118z",
  fill: "#005054"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1554.5 350.118c28.99 0 52.5-23.505 52.5-52.5s-23.51-52.5-52.5-52.5-52.5 23.505-52.5 52.5 23.51 52.5 52.5 52.5z",
  fill: "#00645F"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.59,
  d: "M1554.78 245.118c-9.34 0-18.13 2.4-25.78 6.6l48.83 59.4s30.17-1.032 30.17-13.08c0-29.232-23.82-52.92-53.22-52.92z",
  fill: "#00A872"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M121.5 346.118c28.995 0 52.5-23.505 52.5-52.5s-23.505-52.5-52.5-52.5-52.5 23.505-52.5 52.5 23.505 52.5 52.5 52.5z",
  fill: "#00645F"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.59,
  d: "M121.778 240.118c-9.341 0-18.127 2.4-25.778 6.6l48.829 59.4S175 305.086 175 293.038c0-29.232-23.823-52.92-53.222-52.92z",
  fill: "#00A872"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1014 365.118l-263-.477V202.324l82.606-73.444 51.141-47.762 46.695 47.762 82.318 82.672.24 153.566z",
  fill: "#FFC47B"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M915.643 37.322l91.747-.723 206.61-.481-39.44 38.674h11.08l-13.82 20.844-217.095.482-53.38-2.651L888 82.142l27.643-44.82z",
  fill: "#014163"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M915.058 37.085h91.842l201.1-.967-250.48 59.758-39.838.242L885 86.198l30.058-49.113z",
  fill: "#222350"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M905 97.118l284 .452v262.548l-141.28-.715V217.897L905 97.117z",
  fill: "url(#house-with-surroundings_svg__house-with-surroundings_svg__paint4_linear)"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1350 365.118h-168V91.855l84-71.737 84 76.03v268.97z",
  fill: "url(#house-with-surroundings_svg__house-with-surroundings_svg__paint5_linear)"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M795 252.118h7v18h-7z"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  d: "M835.5 355.118a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm0-70a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm0 18a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm0 18a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm0 18a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm56 17a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm0-71a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm0 18a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm0 19a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm0 18a2.5 2.5 0 100-5 2.5 2.5 0 000 5z",
  fill: "#FFC06B"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  clipRule: "evenodd",
  d: "M914 233.118c18.778 0 34-15.223 34-34 0-18.778-15.222-34-34-34s-34 15.222-34 34c0 18.777 15.222 34 34 34z",
  stroke: "#FFC06B"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1350 365.118l57-27.629V88.118l-57 4.049v272.951z",
  fill: "url(#house-with-surroundings_svg__house-with-surroundings_svg__paint6_linear)"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFB87B",
  d: "M970 178.118h12v188h-12zm-28-23h12v212h-12z"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFB77B",
  d: "M913 119.118h12v247h-12z"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFB87B",
  d: "M885 104.118h12v262h-12zm-16 261h-12V120.265l12-12.147v257zm-28.069 1H829v-221.2l12-8.8-.069 230zm-40.931-202h12v202h-12zm-29 22h12v179h-12z"
});

var _ref31 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1341.99 314.016v12.305h-161.87v-12.305h161.87zm-1.79-29.105v12.305h-161.87v-12.305h161.87zm.11-27.202v12.305h-161.87v-12.305h161.87zm1.66-31.254v12.305H1180.1v-12.305h161.87zm-2.64-26.188v11.351h-162.44v-11.351h162.44zm.35-29.498v12.781h-168.1v-12.781h168.1zm-.16-29.481v12.781h-168.1v-12.781h168.1zm.15-29.613v12.781h-168.09v-12.781h168.09z",
  fill: "#668EBE"
});

var _ref32 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1176.61 325.216v12.305h-128.79v-12.305h128.79zm-.1-28.399v12.305h-128.8v-12.305h128.8zm.01-28.392v12.305h-128.8v-12.305h128.8zm-129.07-44.307l-3.45-12 132 .023v11.977h-128.55zm-22.64-29l-14.81-12h161v12h-146.19zm-27.83-28l-13.98-12h193v12H996.98zm-34.151-28l-13.829-12h222v11.976l-208.171.024z",
  fill: "#7486B9"
});

var _ref33 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#F6E7DB",
  d: "M1339 87.118h11v279h-11zm-167.48 133H1048v-6h124l-.48 6z"
});

var _ref34 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#F6E7DB",
  d: "M1183 337.118h157v28h-157zm-10.95 29H1183V92.786l-11-1.668.05 275z"
});

var _ref35 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1152 96.118h25.2l74.88-79.408 85.2 79.17H1350L1246.8.118l-94.8 96z",
  fill: "#F6E7DB"
});

var _ref36 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1169 91.118l78.56-80 5.44 5.508-70.04 74.492H1169z",
  fill: "#E6CACD"
});

var _ref37 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1182 90.877l23.7-.24 54.57-56.731 68.22 57.212h5.51l-81.15-75-70.73 74.88-.12-.12z",
  fill: "#7A98C2"
});

var _ref38 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1341 96.118h-179l3.52-6 175.48.068v5.932z",
  fill: "#F6E7DB"
});

var _ref39 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.34,
  d: "M1040 101.595l132-.477v57l-132-56.523z",
  fill: "url(#house-with-surroundings_svg__house-with-surroundings_svg__paint7_linear)"
});

var _ref40 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1172 101.118H913.352L909 95.598l263-.48v6z",
  fill: "#F6E7DB"
});

var _ref41 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M1112 266.118h7v99h-7z"
});

var _ref42 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1013 214.835v150.283l34-5.744V214.118l-34 .717z",
  fill: "#ED9A76"
});

var _ref43 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#F4E8DB",
  d: "M1206 120.118h41v72h-41z"
});

var _ref44 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#81D2DB",
  d: "M1212 126.118h30v30h-30z"
});

var _ref45 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#01375C",
  d: "M1212 157.118h30v30h-30z"
});

var _ref46 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#F4E8DB",
  d: "M1201 114.118h51v7h-51z"
});

var _ref47 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M1205 192.118h43v2h-43z"
});

var _ref48 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1212 156.069l7.24.049 2.88-24h14.82l5.04 19.78.02-25.78h-30v29.951z",
  fill: "#7E9CB9"
});

var _ref49 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1212 187.118v-30h30v30l-4.7-24.626-13.48-.049-1.92 24.675h-9.9z",
  fill: "#230B40"
});

var _ref50 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#F4E8DB",
  d: "M1225 126.118h2v30h-2z"
});

var _ref51 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1047.64 218.118H1171v43h-157l33.64-43z",
  fill: "#014163"
});

var _ref52 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1171.76 218.118l.24 43h-124l123.76-43z",
  fill: "#222350"
});

var _ref53 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1172 267.118h-157v-6h157v6z",
  fill: "#fff"
});

var _ref54 =
/*#__PURE__*/
React.createElement("path", {
  d: "M725 219.643h30.119l117.608-117.667 129.083 118.142 12.19-.475L864.839 76.118 725 219.643z",
  fill: "#F7E8DC"
});

var _ref55 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1015 365.118h-11v-151l11 3.11v147.89zm-258 0h-11v-149l11 3.114v145.886z",
  fill: "#F6E7DB"
});

var _ref56 =
/*#__PURE__*/
React.createElement("path", {
  d: "M976 365.118l-189-.716V251.118h189v114z",
  fill: "#F7E8DC"
});

var _ref57 =
/*#__PURE__*/
React.createElement("path", {
  d: "M742 219.118l123.336-125 7.664 6.948-117.434 118.052H742z",
  fill: "#E6CACD"
});

var _ref58 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#F6E7DB",
  d: "M753 219.118h252v8H753zm380 56h32v68h-32z"
});

var _ref59 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#06093D",
  d: "M1137 280.118h25v61h-25z"
});

var _ref60 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.39,
  d: "M758 218.407l27.614.711 93.791-93.316 113.787 93.079H1002L874.406 102.118 758 218.407z",
  fill: "#E08663"
});

var _ref61 =
/*#__PURE__*/
React.createElement("path", {
  d: "M916 141.118h-80l7.381-7.516 63.809-.484 8.81 8z",
  fill: "#E6CACD"
});

var _ref62 =
/*#__PURE__*/
React.createElement("path", {
  d: "M879 134.118h4v-21.753l-3.879-3.247-.121 25z",
  fill: "#E6CACD"
});

var _ref63 =
/*#__PURE__*/
React.createElement("path", {
  d: "M864 141.118l7.678-7.75 14.636-.25 8.686 7.925-31 .075z",
  fill: "#F7E8DC"
});

var _ref64 =
/*#__PURE__*/
React.createElement("path", {
  d: "M880.15 127.118l3.85 3.743v3.03s-4.225.509-3.991 0c.235-.509.141-6.773.141-6.773z",
  fill: "#F7E8DC"
});

var _ref65 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#F4E8DB",
  d: "M1217 136.118h11v1h-11zm6 2h11v1h-11zm5 3h11v1h-11zm-12 7h11v1h-11zm59-28h41v72h-41z"
});

var _ref66 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#81D2DB",
  d: "M1280 126.118h30v30h-30z"
});

var _ref67 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#01375C",
  d: "M1280 157.118h30v30h-30z"
});

var _ref68 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#F4E8DB",
  d: "M1271 114.118h51v7h-51z"
});

var _ref69 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M1275 192.118h43v2h-43z"
});

var _ref70 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1280 156.069l7.24.049 2.88-24h14.82l5.04 19.78.02-25.78h-30v29.951z",
  fill: "#7E9CB9"
});

var _ref71 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1280 187.118v-30h30v30l-4.7-24.626h-19.52l-5.78 24.626z",
  fill: "#230B40"
});

var _ref72 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#F4E8DB",
  d: "M1294 126.118h2v30h-2z"
});

var _ref73 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#F4E8DB",
  d: "M1286 136.118h11v1h-11zm5 2h11v1h-11zm6 3h11v1h-11zm-13 7h11v1h-11zm-246-28h41v72h-41z"
});

var _ref74 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#81D2DB",
  d: "M1043 126.118h30v30h-30z"
});

var _ref75 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#01375C",
  d: "M1043 157.118h30v30h-30z"
});

var _ref76 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#F4E8DB",
  d: "M1033 117.118h51v5h-51z"
});

var _ref77 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M1036 192.118h43v2h-43z"
});

var _ref78 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1043 155.069l7.24.049 2.88-24h14.82l5.04 19.78.02-25.78h-30v29.951z",
  fill: "#7E9CB9"
});

var _ref79 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1043 187.118v-30h30v30l-4.7-24.626-13.48-.049-1.92 24.675h-9.9z",
  fill: "#230B40"
});

var _ref80 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#F4E8DB",
  d: "M1057 125.118h2v30h-2zm9 10.88h11v.238h-11z"
});

var _ref81 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#F4E8DB",
  d: "M1047 134.998h11v.238h-11zm7-2h11v.238h-11zm-6 11h11v.238h-11zm6-5.88h11v1h-11zm5 3h11v1h-11zm-12 7h11v1h-11z"
});

var _ref82 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#F6E7DB",
  d: "M1109 120.118h41v72h-41z"
});

var _ref83 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#81D2DB",
  d: "M1114 125.118h30v30h-30z"
});

var _ref84 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#01375C",
  d: "M1114 157.118h30v30h-30z"
});

var _ref85 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#F4E8DB",
  d: "M1104 117.118h51v5h-51z"
});

var _ref86 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M1108 192.118h43v2h-43z"
});

var _ref87 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1114 155.069l7.24.049 2.88-24h14.82l5.04 19.78.02-25.78h-30v29.951z",
  fill: "#7E9CB9"
});

var _ref88 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1114 187.118v-30h30v30l-4.7-24.626h-19.52l-5.78 24.626z",
  fill: "#230B40"
});

var _ref89 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#F4E8DB",
  d: "M1128 125.118h2v30h-2z"
});

var _ref90 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#F4E8DB",
  d: "M1119 135.118h11v1h-11zm6 3h11v1h-11zm1-6h11v1h-11zm1-2h11v1h-11zm3 11h11v1h-11zm-12 7h11v1h-11zm3 1h11v1h-11zm-5-6h11v1h-11z"
});

var _ref91 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#F6EBDF",
  d: "M1206 237.118h41v72h-41z"
});

var _ref92 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#81D2DB",
  d: "M1212 242.118h30v30h-30z"
});

var _ref93 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#01375C",
  d: "M1212 276.118h30v30h-30z"
});

var _ref94 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M1205 309.118h43v2h-43z"
});

var _ref95 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1212 272.069l7.24.049 2.88-24h14.82l5.04 19.78.02-25.78h-30v29.951z",
  fill: "#7E9CB9"
});

var _ref96 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1212.07 307.118l-.07-32h30v29.151l-4.7-23.929-13-.047-3.36 26.825h-8.87z",
  fill: "#230B40"
});

var _ref97 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#F4E8DB",
  d: "M1225 243.118h2v30h-2z"
});

var _ref98 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#F4E8DB",
  d: "M1217 252.118h11v1h-11zm6 3h11v1h-11zm5 4h11v1h-11zm-12 5h11v1h-11zm59-27h41v72h-41z"
});

var _ref99 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#81D2DB",
  d: "M1280 242.118h30v30h-30z"
});

var _ref100 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#01375C",
  d: "M1280 275.118h30v30h-30z"
});

var _ref101 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M1275 309.118h43v2h-43z"
});

var _ref102 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1280 273.069l7.24.049 2.88-24h14.82l5.04 19.78.02-25.78h-30v29.951z",
  fill: "#7E9CB9"
});

var _ref103 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1280 305.118v-30h30v30l-4.7-24.626h-19.52l-5.78 24.626z",
  fill: "#230B40"
});

var _ref104 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#F4E8DB",
  d: "M1294 243.118h2v30h-2z"
});

var _ref105 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#F4E8DB",
  d: "M1286 255.118h11v1h-11z"
});

var _ref106 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#F4E8DB",
  d: "M1291 255.118h11v1h-11zm6 4h11v1h-11zm-13 5h11v1h-11z"
});

var _ref107 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1013.65 220.118l33.35-5.237L898.827 76.356 865 76.118l148.65 144z",
  fill: "#014163"
});

var _ref108 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1014 220.118L898.907 76.356 865 76.118l149 144z",
  fill: "#222350"
});

var _ref109 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1204.86 238.118l-4.86-7.286s8.22-9.714 25.86-9.714c15.71 0 25.14 9.945 25.14 9.945l-4.62 7.055h-41.52zm71-1l-4.86-7.286s8.22-9.714 25.86-9.714c15.71 0 25.14 9.945 25.14 9.945l-4.62 7.055h-41.52z",
  fill: "#F4E8DB"
});

var _ref110 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1120 297.181s10.3-16.617 27.07-16.376c16.04.24 24.93 17.313 24.93 17.313l-.02-31H1120v30.063z",
  fill: "#F6E7DB"
});

var _ref111 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#E6CACD",
  d: "M1120 267.118h52v2h-52z"
});

var _ref112 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1273 81.118h-23V50.142c0-1.874 1.41-4.008 3.59-4.791 2.1-.76 4.94-1.233 7.96-1.233 2.32 0 5.34.569 7.69 1.375 2.28.76 3.76 2.965 3.76 4.91v30.715z",
  fill: "#F7E7DD"
});

var _ref113 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1254 62.118v-8.699c0-1.492.93-3.695 2.35-4.315 1.37-.596 3.22-.986 5.2-.986 1.51 0 3.41.344 5.01 1.078 1.7.78 2.44 2.846 2.44 4.407v8.492h-15v.023z",
  fill: "#A4DEE4"
});

var _ref114 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#13597A",
  d: "M1254 64.118h15v15h-15z"
});

var _ref115 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#F7E7DD",
  d: "M1260 46.118h2v32h-2z"
});

var _ref116 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.34,
  d: "M1350 157.379l57-15.261v11.523l-57 16.477v-12.739zm0-29l57-15.261v11.523l-57 16.477v-12.739zm0-31.122l57-7.14v3.366l-57 16.635V97.257zm0 89.122l57-15.261v11.523l-57 16.477v-12.739zm0 27l57-15.261v11.523l-57 16.477v-12.739z",
  fill: "#668EBE"
});

var _ref117 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1371 357.093l-9 3.025.05-266.048 8.95-.952v263.975z",
  fill: "url(#house-with-surroundings_svg__house-with-surroundings_svg__paint8_linear)"
});

var _ref118 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1382 114.231v70.887l16-4.79v-69.21l-16 3.113z",
  fill: "#C6BDC2"
});

var _ref119 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1468 345.118c47.5 0 86-38.504 86-86 0-47.497-38.5-86-86-86s-86 38.503-86 86c0 47.496 38.5 86 86 86zm-378 20s1.46-10.435 11.04-16.391c8.16-5.078 19.97-4.293 24.26-.761 4.3 3.532 9.7 17.152 9.7 17.152h-45z",
  fill: "#008187"
});

var _ref120 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#E1C1C5",
  d: "M1121 350.118h51v7h-51zm6-7h45v7h-45z"
});

var _ref121 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#F6E7DB",
  d: "M1127 341.118h45v2h-45zm-6 9h31v1h-31z"
});

var _ref122 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1386 149.213v31.905l11-3.572v-31.428l-11 3.095z",
  fill: "#070634"
});

var _ref123 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1386 145.118l11-3.053v-23.947l-11 2.113v24.887z",
  fill: "#7E9CB9"
});

var _ref124 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1350 346.118l-57 20 57-.233v-19.767z",
  fill: "#E1C1C5"
});

var _ref125 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1439.16 179.118c-33.29 11.749-57.16 43.615-57.16 81.08 0 47.453 38.3 85.92 85.54 85.92 22.61 0 43.18-8.819 58.46-23.214-30.09-48.549-63.02-102.507-86.84-143.786z",
  fill: "url(#house-with-surroundings_svg__house-with-surroundings_svg__paint9_linear)"
});

var _ref126 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1536.21 209.691c-5.76-8.201-12.68-15.082-20.39-20.573-19.82 43.664-44.69 102.195-66.82 155.234 22.44 4.628 46.64.24 66.8-14.147 38.64-27.623 47.8-81.574 20.41-120.514z",
  fill: "url(#house-with-surroundings_svg__house-with-surroundings_svg__paint10_linear)"
});

var _ref127 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.59,
  d: "M1526 321.888a9503.097 9503.097 0 01-39.52-63.77c-12.16 27.929-24.73 57.374-36.48 85.256 22.44 4.572 46.64.236 66.79-13.977a86.05 86.05 0 009.21-7.509z",
  fill: "url(#house-with-surroundings_svg__house-with-surroundings_svg__paint11_linear)"
});

var _ref128 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1408.5 367.118c29.55 0 53.5-23.953 53.5-53.5 0-29.548-23.95-53.5-53.5-53.5s-53.5 23.952-53.5 53.5c0 29.547 23.95 53.5 53.5 53.5z",
  fill: "#18415A"
});

var _ref129 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1408 260.118c6.68 25.31 18.16 67.612 26.7 99 15.73-9.224 26.3-26.311 26.3-45.854 0-29.29-23.72-53.027-53-53.146z",
  fill: "#00986D"
});

var _ref130 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1350 365.118s10.25-28 46-28c36.42 0 46 27.282 46 27.282l-92 .718zm94-10s10.25-28 46-28c36.42 0 46 27.282 46 27.282l-92 .718z",
  fill: "#00855D"
});

var _ref131 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1351 321.351l151-.233v42.766l-2.38.234v-40.43l-148.62.701v-3.038z",
  fill: "#070634"
});

var _ref132 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#070634",
  d: "M1483 324.118h2v41h-2zm-17 0h2v41h-2zm-18.6-.556l1.67-.121 3.02 41.381-1.66.121-3.03-41.381zm-16.4.556h2v41h-2zm-13 0h2v41h-2zm-14 0h2v41h-2zm-15 0h2v41h-2z"
});

var _ref133 =
/*#__PURE__*/
React.createElement("path", {
  d: "M787.088 364.118l-74.088 38h189.627L976 364.835l-188.912-.717z",
  fill: "#F7E7DD"
});

var _ref134 =
/*#__PURE__*/
React.createElement("path", {
  d: "M633 354.118c40.869 0 74-32.012 74-71.5 0-39.489-33.131-71.5-74-71.5s-74 32.011-74 71.5c0 39.488 33.131 71.5 74 71.5z",
  fill: "#01576F"
});

var _ref135 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FB5347",
  d: "M639 301.118h108v58H639z"
});

var _ref136 =
/*#__PURE__*/
React.createElement("path", {
  d: "M747 359.118h-61l21.125-58H747v58z",
  fill: "#BA3543"
});

var _ref137 =
/*#__PURE__*/
React.createElement("path", {
  d: "M748 384.118l228-19.286-188.731-.714-39.269 20z",
  fill: "url(#house-with-surroundings_svg__house-with-surroundings_svg__paint12_linear)"
});

var _ref138 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.55,
  fill: "#fff",
  d: "M787 284.118h189v2H787zm-1-17h189v2H786zm1 35h189v2H787zm0 18h189v2H787zm0 17h189v2H787zm0 15h189v2H787z"
});

var _ref139 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.39,
  fill: "#E08663",
  d: "M782 251.118h5v114h-5z"
});

var _ref140 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.35,
  d: "M792.119 256.365l172.329 6.203L976 353.118l-.119-102H792l.119 5.247z",
  fill: "#E6CACD"
});

var _ref141 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1022 219.261v32.857l6-7.423v-26.577l-6 1.143zm13-3.44v16.297l3.88-5.276.12-11.724-4 .703z",
  fill: "#E08663"
});

var _ref142 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1013 220.076l34-5.958v3.367l-34 6.633v-4.042z",
  fill: "#F6E7DB"
});

var _ref143 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.29,
  fill: "#070634",
  d: "M647 301.118h2v58h-2zm11 0h2v58h-2zm10 0h2v58h-2zm11 0h2v58h-2zm11 0h2v58h-2zm10 0h2v58h-2zm11 0h2v58h-2zm12 0h2v58h-2zm8 0h2v58h-2z"
});

var _ref144 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.34,
  d: "M599.467 218.56c-12.498 6.418-22.473 15.78-29.467 26.734l60.111 38.824s3.197-42.371 5.889-73.979c-12.234-.29-24.78 2.388-36.533 8.421z",
  fill: "#007C84"
});

var _ref145 =
/*#__PURE__*/
React.createElement("path", {
  d: "M655 301.118l51.615-26 .385 25.531-52 .351",
  fill: "#18415A"
});

var _ref146 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.25,
  d: "M1411 396.118c1.1 0 2-.896 2-2 0-1.105-.9-2-2-2s-2 .895-2 2c0 1.104.9 2 2 2z",
  fill: "#fff"
});

var _ref147 =
/*#__PURE__*/
React.createElement("path", {
  d: "M912.664 265.118s-.773-.815-1.545-3.795c-.644-2.471 1.545 0 1.545 0s-2.241-7.871-.515-5.884c3.348 3.821 2.575 9.679 2.833 9.679h-2.318z",
  fill: "#FFABAE"
});

var _ref148 =
/*#__PURE__*/
React.createElement("path", {
  d: "M900 320.667s.949 4.393 8.982 1.415c4.845-1.787 4.893-2.805 4.893-2.805s.706-2.159-1.241-2.159c-4.869 0-12.098 1.613-12.634 3.549z",
  fill: "#09478C"
});

var _ref149 =
/*#__PURE__*/
React.createElement("path", {
  d: "M679 369.641s3.332-35.761 43.548-35.522c37.194.214 43.452 35.999 43.452 35.999l-87-.477z",
  fill: "#00986D"
});

var _ref150 =
/*#__PURE__*/
React.createElement("path", {
  d: "M720.06 334.118c4.828-.023 9.101.453 12.94 1.312l-32.809 34.568-24.191.12c-.024 0 6.325-35.761 44.06-36zm429.94 50l21.11-19H1350l-74.99 17.827-125.01 1.173z",
  fill: "#00645F"
});

var _ref151 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.25,
  d: "M1440 400.118c1.1 0 2-.896 2-2 0-1.105-.9-2-2-2s-2 .895-2 2c0 1.104.9 2 2 2zm24-12c1.1 0 2-.896 2-2 0-1.105-.9-2-2-2s-2 .895-2 2c0 1.104.9 2 2 2z",
  fill: "#fff"
});

var _ref152 =
/*#__PURE__*/
React.createElement("path", {
  d: "M923 377.014c0 1.593-53.397 11.104-67.168 11.104-13.77 0 13.723-8.69 17.334-11.104 1.324-.893 11.146-2.896 24.917-2.896S923 375.421 923 377.014z",
  fill: "url(#house-with-surroundings_svg__house-with-surroundings_svg__paint13_linear)"
});

var _ref153 =
/*#__PURE__*/
React.createElement("path", {
  d: "M852 378.618c0 .825-24.081 5.5-30.975 5.5-6.894 0 6.026-4.675 6.026-5.5 0-.825 5.593-1.5 12.487-1.5s12.462.675 12.462 1.5z",
  fill: "url(#house-with-surroundings_svg__house-with-surroundings_svg__paint14_linear)"
});

var _ref154 =
/*#__PURE__*/
React.createElement("path", {
  d: "M886 373.118h9.435l10.646-42.91 1.935 42.91H916s-1.694-22.048-1.694-27.026v-27.974l-13.306.711s-7.016 22.995-7.742 26.789c-.726 3.793-7.258 27.5-7.258 27.5z",
  fill: "#014163"
});

var _ref155 =
/*#__PURE__*/
React.createElement("path", {
  d: "M905.663 292.717s4.847-.237 4.847-.946 1.939-.945 2.424-2.127c.485-1.182 2.666-10.163 2.666-10.163l-2.423-15.363h2.423s4.121 13.236 4.363 14.181c.243.945-.727 15.6-2.424 19.854-.824 2.08-1.454 7.091-1.696 9.927-.243 2.836 1.939 6.854-.485 9.691-.945 1.111-12.531 2.812-13.815 2.127-2.667-1.418-.728-12.291-.485-13.709.242-1.418-3.878 10.4-3.878 10.4s-1.939 5.436-7.271 9.454c-.655.497-2.909-1.654-2.909-1.654l6.787-13.709s2.617-12.622 5.574-15.6c1.164-1.181 6.302-2.363 6.302-2.363z",
  fill: "url(#house-with-surroundings_svg__house-with-surroundings_svg__paint15_linear)"
});

var _ref156 =
/*#__PURE__*/
React.createElement("path", {
  d: "M904.625 292.658s4.184-.637 4.838-.943c1.935-.944 5.079-12.266 5.079-12.266l-2.419-15.331h2.419s1.572 18.374 1.451 19.341c-1.451 11.322-10.159 13.681-11.852 17.926-.822 2.076-2.346 18.846-3.628 18.162-2.661-1.415-2.419-16.275-2.177-17.69.242-1.415-3.87 11.322-3.87 11.322s-2.661 8.02-6.773 11.794c-.605.566-1.693-.708-1.693-.708l6.773-13.681s2.612-12.595 5.563-15.567c1.161-1.18 6.289-2.359 6.289-2.359z",
  fill: "#5D86C6"
});

var _ref157 =
/*#__PURE__*/
React.createElement("path", {
  d: "M904.188 290.555v3.209s3.552 1.146 4.499-.688l-.71-3.438s.474-.917.947-2.063c.474-1.146-1.421-5.043-1.657-5.731-.237-.687-4.974-1.833-5.211 1.834-.237 3.668.237 5.731 2.132 6.877z",
  fill: "#FFABAE"
});

var _ref158 =
/*#__PURE__*/
React.createElement("path", {
  d: "M902.029 288.118s.778 0 .778-.546-1.555-4.639-.778-5.457c.778-.819 1.814 2.183 4.405.545.622-.409 1.555-1.91 1.555-1.91s.932 6.085 1.632 6.031c.699-.028.44-6.849-.855-8.486-1.296-1.637-5.648-1.501-7.255 0-2.332 2.183-1.813 6.821.518 9.823z",
  fill: "#18004B"
});

var _ref159 =
/*#__PURE__*/
React.createElement("path", {
  d: "M887 373.118s-6 3.395-6 3.847c0 .453 7.045-.226 7.273-.452.227-.227.909-1.132.909-1.132l.682 1.358h1.363l.773-3.621h-5zm22.72 1s-3.299 1.187-2.631 3.799c.112.451 4.905 0 4.905 0l.446-.95.668.95H914l-.446-3.799h-3.834z",
  fill: "#171756"
});

var _ref160 =
/*#__PURE__*/
React.createElement("path", {
  d: "M836 363.118s45.061-12.949 51-33",
  stroke: "#B27C4F",
  strokeWidth: 3
});

var _ref161 =
/*#__PURE__*/
React.createElement("path", {
  d: "M836.25 380.118l2.75-1-2.25-10-2.75 3.25 3 5.25s-2.5.75-.75 2.5zm12.621 0l2.129-2.063-5.678-8.937-1.322 4.283 4.626 3.967c.024 0-1.983 1.718.245 2.75z",
  fill: "#962A3A"
});

var _ref162 =
/*#__PURE__*/
React.createElement("path", {
  d: "M830.051 359.304s-3.938 3.044-6.022 3.044c0 0-.463 3.278 2.316 3.512 2.779.234 3.937-.937 3.937-.937l.695 6.556s.927 5.62.464 6.322c-.464.703-1.853.937-1.622 1.639.232.703 2.78.703 3.243 0 .463-.702 1.389-5.619 1.389-5.619v-2.342h5.976s-.185 1.873.046 2.576c.232.702 2.548 2.575 2.548 2.575l.463 1.405s-2.316.937-1.853 1.639c.464.703 4.169.469 4.401 0 .232-.468-.695-3.746-.695-3.746l.139-4.449 1.019-6.696s3.243-.562 3.474-2.435c.232-1.873-.926-2.342-.926-2.342s-.463 2.576-1.158 2.81c-.695.234-3.938 2.107-4.401 2.107h-8.338c.348.328.417-1.967-.463-3.278-.255-.398-3.011-3.278-4.632-2.341z",
  fill: "#BB3644"
});

var _ref163 =
/*#__PURE__*/
React.createElement("path", {
  d: "M839 369.118a1 1 0 100-2 1 1 0 000 2zm5.086-2.363c.291-.591.001-1.329-.649-1.65-.649-.32-1.412-.101-1.703.49-.292.59-.001 1.329.649 1.649.649.32 1.412.101 1.703-.489z",
  fill: "#FFB87B"
});

var _ref164 =
/*#__PURE__*/
React.createElement("path", {
  d: "M914 318.118l-10.33 6.484-13.618 48.516H887l13.617-52.839s12.444-.48 13.383-2.161z",
  fill: "#222350"
});

var _ref165 =
/*#__PURE__*/
React.createElement("path", {
  d: "M906 330.118l1.905 3.088L911 373.118h-3.571l-1.429-43z",
  fill: "#222350"
});

var _ref166 =
/*#__PURE__*/
React.createElement("path", {
  d: "M911.025 324.118s-.395 5.454 1.975 6m-11-5s-.667 3.333-2 4",
  stroke: "#020202",
  strokeWidth: 2
});

var _ref167 =
/*#__PURE__*/
React.createElement("path", {
  d: "M828.5 362.118a.5.5 0 100-1 .5.5 0 000 1zm-4.437 2s2.465-1.162 1.833-1.742c-.632-.581-1.896 0-1.896 0s.158 1.422.063 1.742z",
  fill: "#171756"
});

var _ref168 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1112.72 345.118c-3.96.278-8.09 1.39-11.6 3.545-9.65 5.979-11.12 16.455-11.12 16.455h30c-1.86-5.423-4.69-13.396-7.28-20z",
  fill: "#00986D"
});

var _ref169 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1229 378.118s1.67-10.475 12.61-16.454c9.32-5.099 22.65-4.102 27.73-.765 11.08 7.254 14.66 17.219 14.66 17.219h-55z",
  fill: "#008187"
});

var _ref170 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1254.51 358.118c-4.61.278-9.46 1.39-13.54 3.545-11.25 5.979-12.97 16.455-12.97 16.455h35c-2.18-5.423-5.47-13.396-8.49-20z",
  fill: "#00986D"
});

var _ref171 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#E1C1C5",
  d: "M1117 358.118h55v7h-55z"
});

var _ref172 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#F6E7DB",
  d: "M1116 358.118h31v1h-31z"
});

var _ref173 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1150.11 384.118l-22.11 18 113.91-.351 29.09-17.649h-120.89z",
  fill: "url(#house-with-surroundings_svg__house-with-surroundings_svg__paint16_linear)"
});

var _ref174 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1381.05 383.118H942.571l-3.571 2h443l-.95-2zm-793.05-1h158v2H590.847l-2.847-2z",
  fill: "#005054"
});

var _ref175 =
/*#__PURE__*/
React.createElement("path", {
  d: "M904 289.056s3.6-.208 3.84-.831c.24-.623.48 1.661-1.44 1.869-1.92.208-2.4-1.038-2.4-1.038zm-1-3.938l2-.8s-.909-.8-2 .8z",
  fill: "#FC997E"
});

var _ref176 =
/*#__PURE__*/
React.createElement("path", {
  d: "M886.222 324.457s-2.222.41-2.222 4.099c0 3.69 3.457 2.204 3.457 2.204s.494-1.845 0-3.075c-.494-1.23.741 3.997 1.234 3.382.494-.615.247-5.329.247-5.329s-1.728-2.511-2.716-1.281z",
  fill: "#FFABAE"
});

var _ref177 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1022 267.118v97l6-.979-.07-96.021H1022zm13-1v95l6-.887v-94.113h-6z",
  fill: "#E08663"
});

var _ref178 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1348 92.975l62-7.857v3.404l-58.91 7.596-3.09-3.143z",
  fill: "#F6E7DB"
});

var _ref179 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1229.13 378.118l-8.13 4h54.22c1.41 0 8.78-4 8.78-4h-54.87zM0 381.118h525v4H0z",
  fill: "#005054"
});

var _ref180 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#EFA554",
  d: "M182 186.118h8v161h-8z"
});

var _ref181 =
/*#__PURE__*/
React.createElement("path", {
  d: "M182 346.118v-161h8l-8 161z",
  fill: "#D37F54"
});

var _ref182 =
/*#__PURE__*/
React.createElement("path", {
  d: "M359.5 346.118c45.563 0 82.5-38.504 82.5-86 0-47.497-36.937-86-82.5-86s-82.5 38.503-82.5 86c0 47.496 36.937 86 82.5 86z",
  fill: "#00645F"
});

var _ref183 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.39,
  d: "M318.338 186.679c-16.955 9.784-28.968 24.661-35.338 41.635 29.234 12.283 80 31.804 80 31.804l-12.788-84a82.53 82.53 0 00-31.874 10.561z",
  fill: "#00986D"
});

var _ref184 =
/*#__PURE__*/
React.createElement("path", {
  d: "M256 364.118c35.899 0 65-29.102 65-65 0-35.899-29.101-65-65-65s-65 29.101-65 65c0 35.898 29.101 65 65 65z",
  fill: "#00A872"
});

var _ref185 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.92,
  d: "M238.179 362.118L256 299.639l-53.175-37.521A64.802 64.802 0 00191 299.519c0 29.753 19.932 54.831 47.179 62.599z",
  fill: "#00986D"
});

var _ref186 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1866.5 343.118c48.32 0 87.5-39.176 87.5-87.5 0-48.325-39.18-87.5-87.5-87.5s-87.5 39.175-87.5 87.5c0 48.324 39.18 87.5 87.5 87.5z",
  fill: "url(#house-with-surroundings_svg__house-with-surroundings_svg__paint17_linear)"
});

var _ref187 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1808 317.618c0 23.463-19.04 42.5-42.5 42.5s-42.5-19.037-42.5-42.5c0-10.75 4-20.576 10.58-28.058 7.79-8.855 19.21-14.442 31.92-14.442 23.46 0 42.5 19.036 42.5 42.5z",
  fill: "#00A872"
});

var _ref188 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1858 168.736l10.34 86.382 86.66-9.295c-4.64-43.666-41.68-77.705-86.66-77.705-3.5 0-6.96.213-10.34.618z",
  fill: "url(#house-with-surroundings_svg__house-with-surroundings_svg__paint18_linear)"
});

var _ref189 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1808 321.025l120-70.907v72l-120-1.093z",
  fill: "#18415A"
});

var _ref190 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1978.5 349.118c34.52 0 62.5-27.983 62.5-62.5 0-34.518-27.98-62.5-62.5-62.5-34.52 0-62.5 27.982-62.5 62.5 0 34.517 27.98 62.5 62.5 62.5z",
  fill: "#00645F"
});

var _ref191 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.59,
  d: "M1934.4 240.691a65.286 65.286 0 00-6.4 7.525l107.24 65.902c11.95-23.779 8.06-53.568-11.71-73.427-24.61-24.764-64.51-24.764-89.13 0z",
  fill: "#00A872"
});

var _ref192 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFC47B",
  d: "M1722 321.118h308v45h-308z"
});

var _ref193 =
/*#__PURE__*/
React.createElement("path", {
  d: "M2030 366.118h-308v-45l308 45z",
  fill: "#F7AD77"
});

var _ref194 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.39,
  d: "M261.462 364.799c14.319-1.456 26.968-7.898 36.538-17.489-15.513-17.346-43.005-46.192-43.005-46.192L237 362.222a59.44 59.44 0 0024.462 2.577z",
  fill: "#00986D"
});

var _ref195 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1800 320.118l-66.14-31s-12.18 8.476-10.74 31H1800z",
  fill: "#00645F"
});

var _ref196 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.29,
  d: "M1734 323.118v43m15-43v43m16-44v43m15-42v43m15-43v43m17-43v43m14-43v43m15-43v43m16-43v43m16-43v43m16-43v43m14-43v43m15-43v43m17-43v43m15-44v43m15-42v43m15-44v43m16 0v-43m15 0v43m15-43v43",
  stroke: "#070634",
  strokeWidth: 3
});

var _ref197 =
/*#__PURE__*/
React.createElement("path", {
  d: "M500 403.118s8.877-34.164 56.367-32.97c36.823.932 47.633 32.97 47.633 32.97H500z",
  fill: "#00645F"
});

var _ref198 =
/*#__PURE__*/
React.createElement("path", {
  d: "M603 403.118s-10.652-32.045-47.038-32.977c-.637-.023-1.273-.023-1.886-.023l-11.076 33h60zm1462-35s-4.38-24.066-30.3-25c0 0-28.99 1.518-29.7 24.883l60 .117z",
  fill: "#00A872"
});

var _ref199 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFC47B",
  d: "M307 320.118h2v47h-2zm22 2h2v45h-2zm23 0h2v45h-2zm-111-2h2v47h-2zm22 2h2v45h-2zm22 0h2v45h-2zm-111-1h2v47h-2zm23 2h2v45h-2zm22 0h2v45h-2zm-113 0h2v45h-2zm-21 0h2v45h-2zm44 0h2v45h-2zm23 0h2v45h-2zm224.142-3.243l2.325.228-4.651 47.44-2.325-.228 4.651-47.44z"
});

var _ref200 =
/*#__PURE__*/
React.createElement("path", {
  d: "M164.317 254.287l17.561 18.033.122 4.798-25-25 7.317 2.169z",
  fill: "#FFA26E"
});

var _ref201 =
/*#__PURE__*/
React.createElement("path", {
  d: "M2051.08 347.118l-17.08 19.93 32 .07s-2.5-13.133-14.92-20z",
  fill: "#00B56F"
});

var _ref202 =
/*#__PURE__*/
React.createElement("path", {
  d: "M455 355.118s-4.379-24.066-30.296-25c0 0-28.994 1.518-29.704 24.883l60 .117z",
  fill: "#00A872"
});

var _ref203 =
/*#__PURE__*/
React.createElement("path", {
  d: "M439.559 335.118L423 355.048l31 .07s-2.427-13.149-14.441-20z",
  fill: "#00B56F"
});

var _ref204 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1679.32 334.118l18.68 23.926-35 .074s2.74-15.78 16.32-24z",
  fill: "#00855D"
});

var _ref205 =
/*#__PURE__*/
React.createElement("path", {
  d: "M181.5 259.118c26.234 0 47.5-21.267 47.5-47.5 0-26.234-21.266-47.5-47.5-47.5s-47.5 21.266-47.5 47.5c0 26.233 21.266 47.5 47.5 47.5z",
  fill: "url(#house-with-surroundings_svg__house-with-surroundings_svg__paint19_linear)"
});

var _ref206 =
/*#__PURE__*/
React.createElement("path", {
  d: "M139.571 233.897c4.245 8.137 10.446 14.661 17.72 19.221L183 213.952s-28.047-2.081-48.986-3.834c-.191 7.926 1.574 16.11 5.557 23.779z",
  fill: "#01576F"
});

var _ref207 =
/*#__PURE__*/
React.createElement("path", {
  d: "M447.202 309.527l1.994.195-6.948 70.864-1.993-.195 6.947-70.864z",
  fill: "#FEFEFE"
});

var _ref208 =
/*#__PURE__*/
React.createElement("path", {
  d: "M433.154 304.817l30.472 1.276-.292 6.981-30.473-1.276.293-6.981z",
  fill: "#fff"
});

var _ref209 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.38,
  d: "M446.875 312.118l2.125.094-4 17.906 1.875-18zm-6.875 68l6-38-3.951 38H440z",
  fill: "#CAECE9"
});

var _ref210 =
/*#__PURE__*/
React.createElement("path", {
  d: "M66.171 368.118L63 321.603l342-3.485-1.669 50h-3.577l1.192-46.875-334.393 3.269 2.48 43.606H66.17z",
  fill: "#FFC47B"
});

var _ref211 =
/*#__PURE__*/
React.createElement("path", {
  d: "M100 368.118s-4.379-24.066-30.296-25c0 0-28.994 1.518-29.704 24.883l60 .117z",
  fill: "#00A872"
});

var _ref212 =
/*#__PURE__*/
React.createElement("path", {
  d: "M86.559 347.118L70 367.048l31 .07s-2.427-13.149-14.441-20z",
  fill: "#00B56F"
});

var _ref213 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1590 383.118h-112l.24 2H1590v-2zm66-2h509v3h-509z",
  fill: "#005054"
});

var _ref214 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1570 403.118s8.88-34.164 56.37-32.97c36.82.932 47.63 32.97 47.63 32.97h-104z",
  fill: "#00A872"
});

var _ref215 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1673 403.118s-10.65-32.045-47.04-32.977c-.63-.023-1.27-.023-1.88-.023l-11.08 33h60z",
  fill: "#00645F"
});

var _ref216 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1309 0l97.5 85.5L1348 93l-39-93z",
  fill: "#014163"
});

var _ref217 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1309 0h-62l101 93-39-93z",
  fill: "#222350"
});

var _ref218 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "house-with-surroundings_svg__house-with-surroundings_svg__paint10_linear",
  x1: 1550.42,
  y1: 309.879,
  x2: 1548.1,
  y2: 157.892,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#008A90"
}), React.createElement("stop", {
  offset: 0.999,
  stopColor: "#008083"
})), React.createElement("linearGradient", {
  id: "house-with-surroundings_svg__house-with-surroundings_svg__paint0_linear",
  x1: 59,
  y1: 332.118,
  x2: 455,
  y2: 332.118,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#6C90BD"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#7498DF"
})), React.createElement("linearGradient", {
  id: "house-with-surroundings_svg__house-with-surroundings_svg__paint2_linear",
  x1: 2024.98,
  y1: 354.138,
  x2: 2105,
  y2: 354.138,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#008A90"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#016879"
})), React.createElement("linearGradient", {
  id: "house-with-surroundings_svg__house-with-surroundings_svg__paint3_linear",
  x1: 2035.99,
  y1: 319.124,
  x2: 2103.01,
  y2: 319.124,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#008A90"
}), React.createElement("stop", {
  offset: 0.999,
  stopColor: "#008083"
})), React.createElement("linearGradient", {
  id: "house-with-surroundings_svg__house-with-surroundings_svg__paint4_linear",
  x1: 905,
  y1: 360.118,
  x2: 1189,
  y2: 360.118,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#6C90BD"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#7498DF"
})), React.createElement("linearGradient", {
  id: "house-with-surroundings_svg__house-with-surroundings_svg__paint5_linear",
  x1: 1189.19,
  y1: 73.974,
  x2: 1209.57,
  y2: 377.838,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#98BFDC"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#7498DF"
})), React.createElement("linearGradient", {
  id: "house-with-surroundings_svg__house-with-surroundings_svg__paint6_linear",
  x1: 1460.77,
  y1: -173.695,
  x2: 1291.74,
  y2: -174.602,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#6C90BD"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#564D89"
})), React.createElement("linearGradient", {
  id: "house-with-surroundings_svg__house-with-surroundings_svg__paint7_linear",
  x1: 1152.1,
  y1: 182.155,
  x2: 1181.09,
  y2: 81.142,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#544FAF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#594C89"
})), React.createElement("linearGradient", {
  id: "house-with-surroundings_svg__house-with-surroundings_svg__paint8_linear",
  x1: 1289.15,
  y1: 2265.72,
  x2: 1426.2,
  y2: 2265.71,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#6C90BD"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#564D89"
})), React.createElement("linearGradient", {
  id: "house-with-surroundings_svg__house-with-surroundings_svg__paint9_linear",
  x1: 1526.44,
  y1: 345.568,
  x2: 1524.96,
  y2: 178.39,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#008A90"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#016879"
})), React.createElement("linearGradient", {
  id: "house-with-surroundings_svg__house-with-surroundings_svg__paint1_linear",
  x1: 1691.01,
  y1: 334.116,
  x2: 2111,
  y2: 334.116,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#6C90BD"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#7498DF"
})), React.createElement("linearGradient", {
  id: "house-with-surroundings_svg__house-with-surroundings_svg__paint11_linear",
  x1: 1526.04,
  y1: 344.656,
  x2: 1525.28,
  y2: 257.784,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#008A90"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#016879"
})), React.createElement("linearGradient", {
  id: "house-with-surroundings_svg__house-with-surroundings_svg__paint12_linear",
  x1: 1092.64,
  y1: 372.37,
  x2: 1089.23,
  y2: 328.444,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#E7C7CD"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#9FACA8"
})), React.createElement("linearGradient", {
  id: "house-with-surroundings_svg__house-with-surroundings_svg__paint13_linear",
  x1: 941.046,
  y1: 369.076,
  x2: 822.859,
  y2: 381.466,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#E7C7CD"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#9FACA8"
})), React.createElement("linearGradient", {
  id: "house-with-surroundings_svg__house-with-surroundings_svg__paint14_linear",
  x1: 860.41,
  y1: 374.6,
  x2: 805.359,
  y2: 379.757,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#E7C7CD"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#9FACA8"
})), React.createElement("linearGradient", {
  id: "house-with-surroundings_svg__house-with-surroundings_svg__paint15_linear",
  x1: 887,
  y1: 326.118,
  x2: 920,
  y2: 326.118,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#6C90BD"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#7498DF"
})), React.createElement("linearGradient", {
  id: "house-with-surroundings_svg__house-with-surroundings_svg__paint16_linear",
  x1: 1317.31,
  y1: 378.406,
  x2: 1199.9,
  y2: 245.764,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#E7C7CD"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#9FACA8",
  stopOpacity: 0.13
})), React.createElement("linearGradient", {
  id: "house-with-surroundings_svg__house-with-surroundings_svg__paint17_linear",
  x1: 1779,
  y1: 343.118,
  x2: 1954,
  y2: 343.118,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#008A90"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#016879"
})), React.createElement("linearGradient", {
  id: "house-with-surroundings_svg__house-with-surroundings_svg__paint18_linear",
  x1: 1857.99,
  y1: 255.123,
  x2: 1955.01,
  y2: 255.123,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#008A90"
}), React.createElement("stop", {
  offset: 0.999,
  stopColor: "#008083"
})), React.createElement("linearGradient", {
  id: "house-with-surroundings_svg__house-with-surroundings_svg__paint19_linear",
  x1: 134.333,
  y1: 375.412,
  x2: 321.375,
  y2: 253.722,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#008A90"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#016879"
})));

var SvgHouseWithSurroundings = function SvgHouseWithSurroundings(props) {
  return React.createElement("svg", _extends({
    width: 2166,
    height: 404,
    viewBox: "0 0 2166 404",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, _ref133, _ref134, _ref135, _ref136, _ref137, _ref138, _ref139, _ref140, _ref141, _ref142, _ref143, _ref144, _ref145, _ref146, _ref147, _ref148, _ref149, _ref150, _ref151, _ref152, _ref153, _ref154, _ref155, _ref156, _ref157, _ref158, _ref159, _ref160, _ref161, _ref162, _ref163, _ref164, _ref165, _ref166, _ref167, _ref168, _ref169, _ref170, _ref171, _ref172, _ref173, _ref174, _ref175, _ref176, _ref177, _ref178, _ref179, _ref180, _ref181, _ref182, _ref183, _ref184, _ref185, _ref186, _ref187, _ref188, _ref189, _ref190, _ref191, _ref192, _ref193, _ref194, _ref195, _ref196, _ref197, _ref198, _ref199, _ref200, _ref201, _ref202, _ref203, _ref204, _ref205, _ref206, _ref207, _ref208, _ref209, _ref210, _ref211, _ref212, _ref213, _ref214, _ref215, _ref216, _ref217, _ref218);
};

export default __webpack_public_path__ + "static/house-with-surroundings.cb95463e.svg";
export { SvgHouseWithSurroundings as ReactComponent };